"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyText = void 0;
const react_1 = __importStar(require("react"));
const use_is_mounted_1 = require("../hooks/use-is-mounted");
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    button: `
    tw-flex
    tw-items-center
    hover:tw-opacity-80
    focus:tw-outline-none`,
    text: `
    tw-mr-2`,
    svg: `
    tw-h-4
    tw-w-4
    tw-text-current`,
});
const CopyText = ({ text, payload }) => {
    const [copied, setCopied] = (0, react_1.useState)(false);
    const isMountedRef = (0, use_is_mounted_1.useIsMounted)();
    const theme = (0, use_theme_1.default)();
    const onClick = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        yield navigator.clipboard.writeText(payload);
        setCopied(true);
        setTimeout(() => {
            if (isMountedRef.current) {
                setCopied(false);
            }
        }, 4000);
    }), [payload, isMountedRef]);
    return (react_1.default.createElement("button", { onClick: onClick, className: styles.button, style: {
            color: theme.textTertiary,
        } },
        react_1.default.createElement("span", { className: styles.text }, text),
        react_1.default.createElement("svg", { className: styles.svg, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
            react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: copied
                    ? 'M5 13l4 4L19 7'
                    : 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' }))));
};
exports.CopyText = CopyText;
//# sourceMappingURL=copy.js.map